module.exports = __webpack_public_path__ + "img/check.6158a699.svg";